// src/store/actions/lastRouteActions.js

export const SET_LAST_ROUTE = "SET_LAST_ROUTE";
export const CLEAR_LAST_ROUTE = "CLEAR_LAST_ROUTE";

export const setLastRoute = (route: any) => {
  return {
    type: SET_LAST_ROUTE,
    payload: route,
  };
};

export const clearLastRoute = () => {
  return {
    type: CLEAR_LAST_ROUTE,
  };
};
